import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface SidebarItemProps {
  icon: React.ReactNode;
  label: string;
  isExpanded: boolean;
  onToggle: (value: boolean) => void;
  isActive?: boolean;
  children?: React.ReactNode;
  hideChevron?: boolean;
  beta?: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  icon,
  label,
  isExpanded,
  onToggle,
  isActive,
  children,
  hideChevron,
  beta,
}) => {
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={isExpanded ? "item-1" : ""}
      value={isExpanded ? "item-1" : ""}
      onValueChange={(value) => {
        onToggle(value === "item-1");
      }}
    >
      <AccordionItem value="item-1" className="border-none">
        <div
          className={`w-full text-base font-medium rounded-full text-muted-foreground hover:text-foreground dark:hover:text-black hover:bg-sky-100 group ${
            isActive ? "bg-sky-100 text-accent-foreground dark:text-black" : ""
          }`}
        >
          <AccordionTrigger className="px-4 py-2.5" hideChevron={hideChevron}>
            <div className="flex w-full justify-between items-center">
              <div className="flex items-center">
                <span
                  className={`w-5 inline-flex justify-center ${
                    isActive
                      ? "text-accent-foreground dark:text-black"
                      : "group-hover:text-foreground dark:group-hover:text-black"
                  }`}
                >
                  {icon}
                </span>
                <span
                  className={`ml-2 ${
                    isActive
                      ? "text-accent-foreground dark:text-black font-semibold"
                      : "group-hover:text-accent-foreground dark:group-hover:text-black"
                  }`}
                >
                  {label}
                  {beta && (
                    <span className="text-xs text-primary font-bold align-super ml-1">
                      BETA
                    </span>
                  )}
                </span>
              </div>
            </div>
          </AccordionTrigger>
        </div>
        {children && (
          <AccordionContent>
            <div className="space-y-2 mt-2">{children}</div>
          </AccordionContent>
        )}
      </AccordionItem>
    </Accordion>
  );
};

export default SidebarItem;
